import { Search } from '@mui/icons-material/';
import { useEffect, useState } from 'react';

import { getChatByFilter } from '../../../helpers/getChatByFilter';
import { FILTER_VALUE_ACTIVOS, FILTER_VALUE_FINALIZADOS } from '../../../const/filtersValue/filterValue';
import { getChatsFinish } from '../../../helpers/fetch/getChatsFinish';
import Tooltip from '@mui/material/Tooltip';

// SearcherChat: Componente que renderiza un buscador.
// Leer en documentación "/docs" información sobre el componente.

const SearcherChat = ({ dataList, setDataList, setSearching, filterValue, setSearchChatFinish, setChatsOriginal, chatsOriginal }) => {

    const [search, setSearch] = useState("");

    const handleSearch = () => { //Función pora filtrar al operador seleccionado.

        if (search !== '') {
            if (filterValue === FILTER_VALUE_ACTIVOS) { //Filtrar de la lista el valor de search buscado.
                console.log("se está buscando entre los chats activos")
                let searchedByName = dataList.filter((chat) => chat.Nombre.toLocaleLowerCase().includes(search.toLocaleLowerCase()));
                /*             let searchedByNumber= dataList.filter((chat) => chat.Nombre.toLocaleLowerCase().includes(search.toLocaleLowerCase()));
                 */
                if (searchedByName.length > 0) { //Si existe alguna coincidencia con el search buscado.
                    console.log('existe un search con ese nombre', searchedByName);
                    setDataList(searchedByName);   //Actualizar la lista de chats con los que cumplan esa condición.
                }
            }
            if (filterValue === FILTER_VALUE_FINALIZADOS) {
                console.log("se está buscando entre los chats finalizados")
                onGetChatEndedSearched();
            }
        }
        else { //Si el valor ingresado en el buscador es igual a vacío.
            console.log('no existe un search con ese nombre');
            setDataList(chatsOriginal); //Retornar la lista de sugerencias en la lista original.
        }
    };


    const onGetChatEndedSearched = async () => {
        try {
            console.log("BUSCAR CHAT FINALIZADO en SearcherChat.jsx", filterValue, search);
            let chatEnded = await getChatsFinish({ filter: filterValue, chatEndedSearched: search, idLastChatPosition: 0 });
            setDataList(chatEnded);
            setSearchChatFinish(search);
            /* setDataList(chatEnded); */
        } catch (error) {
            console.log("fallo la peticion de BUSCAR CHAT FINALIZADO en SearcherChat.jsx")
        }
    };

    const onChangeSearch = async (e) => {
        setSearch(e.target.value); // Capturar el valor buscado.
        if (e.target.value) { //Si se está buscando un chat.
            console.log("lo que se está busando", e.target.value);
            setDataList(chatsOriginal); //Setear la lista de chats en el Inbox con los chats originales.
            setSearchChatFinish(""); //Vaciar el nombre de la búsqueda de chat finalizado.
            setSearching(true); //Desactivar la opción de que lleguen mensajes al Invbox mientras se está buscando un chat.
        };
        if (e.target.value === '') { //Si no se está buscando un chat.
            setSearching(false); // Activar que puedan llegar mensajes al Inbox.
            setSearchChatFinish(""); //Vaciar el nombre de la búsqueda de chat finalizado.
            setDataList(chatsOriginal); //Actualizar la lista de chats con los chats originales.
        }
    };


    return (
        <div className="input-with-icon">

            <input onChange={(e) => onChangeSearch(e)} value={search}
            /* onKeyDown={handleKeyDown} */
                placeholder="Buscar Chat..." className="search-input" type='text'/>
            <Tooltip title="Buscar Chat" >
                <button className='search-btn' onClick={handleSearch}>
                    <Search className="search-icon" />
                </button>
            </Tooltip>
        </div>
    )
};

export default SearcherChat;